export class RegimentosInternos {

    static regimentosInternosLista: RegimentosInternos[] = [
        { tipo: 'docLink', descricao: 'Regimento Interno', caminho: 'https://www.centrus.org.br/wp-content/uploads/2020/08/regimento_interno_ata588_29112019n.pdf' },
        { tipo: 'docLink', descricao: '22/03/2019 a 28/11/2019', caminho: 'https://sef.centrus.org.br/cent/images/docs/pdf/regimento_interno_ata578_22032019.pdf' },
        { tipo: 'docLink', descricao: '29/11/2017 a 21/03/2019', caminho: 'https://sef.centrus.org.br/cent/images/docs/pdf/regimento_interno_29112017.pdf' },
        { tipo: 'docLink', descricao: '28/09/2017 a 28/11/2017', caminho: 'https://sef.centrus.org.br/cent/images/docs/pdf/regimento_interno_28092017.pdf' },
        { tipo: 'docLink', descricao: '23/02/2017 a 27/09/2017', caminho: 'https://sef.centrus.org.br/cent/images/docs/pdf/regimento_interno_23022017.pdf' },
        { tipo: 'docLink', descricao: '30/11/2015 a 22/02/2017', caminho: 'https://sef.centrus.org.br/cent/images/docs/pdf/regimento_interno_30112015.pdf' },
        { tipo: 'docLink', descricao: '24/06/2015 a 29/11/2015', caminho: 'https://sef.centrus.org.br/cent/images/docs/pdf/regimento_interno_24062015.pdf' },
        { tipo: 'docLink', descricao: '29/04/2015 a 23/06/2015', caminho: 'https://sef.centrus.org.br/cent/images/docs/pdf/regimento_interno_29042015.pdf' },
        { tipo: 'docLink', descricao: '26/08/2009 a 28/04/2015', caminho: 'https://sef.centrus.org.br/cent/images/docs/pdf/regimento_interno_26082009.pdf' },

    ];

    constructor(
        public tipo: string,
        public descricao: string,
        public caminho: string
    ) {
    }



}




// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/util/dados-documentos-institucional/lista-documentos/regimentos-internos-pdf.ts